import { h, Component } from 'preact';
import style from './style';

export default class OTT extends Component {
	render(props, state) {
		return (
			<div class={'modalWrapper'}>
        <div class={'modalContainer'}>
          {props.content}
        </div>

				{this.props.showControls ? 
					<div class={'controls'}>
						{this.props.customControl ? 
							this.props.customControl : null
						}
						<div class={'iconClose'} onClick={this.handleClick.bind(this)}>
							<i class="zmdi zmdi-close"></i>	
						</div>
					</div> : null
				}
				
      </div>
		);
	}

	handleClick() {
		this.props.toggleModal(false, null);
	}
}



// WEBPACK FOOTER //
// ./components/spareparts/modal/index.js